import React, {Fragment, Component} from "react";
import {withFormik, Field, FieldArray} from "formik";
import SubmitButton from "../SubmitButton";
import {FORM_ERRORS} from "../../../texts";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Creators as ClientesActions} from "../../../store/ducks/clientes";
import {Creators as ProdutosActions} from "../../../store/ducks/produtos";
import {Creators as ModalActions} from "../../../store/ducks/modal";
import {Creators as ModalCustomerActions} from "../../../store/ducks/modalCustomer";
import {Creators as StorePageActions} from "../../../store/ducks/PageStores/clientesStores";
import DefaultButton from "../../../components/DefaultButton";
import $ from "jquery";
// eslint-disable-next-line
import mask from "jquery-mask-plugin";
import PrimaryButton from "../../../components/PrimaryButton";
import SecondaryButton from "../../SecondaryButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import {formatMoney} from "../../../helpers";
import Currency from "../../Currency";
import api from "../../../services/api";
import moment from "moment";

const CurrencyInput = ({field, form, ...rest}) => (
  <Currency {...field} {...rest} />
);

export class Form extends Component {
  state = {
    origins: [],
    loadingOrigins: false,
  };

  componentDidMount() {
    $(".input-date").mask("00/00/0000");
    $(".zipcode").mask("00000-000");
    this.props.getListProdutosSelects();
    this.setState({loadingOrigins: true});
    api
      .get(`/origins/select`)
      .then(data => {
        const {data: origins} = data;
        this.setState({
          origins: origins,
          loadingOrigins: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleMaskPhone = phone => {
    var texto = phone;
    texto = texto.replace(/[^\d]/g, "");
    if (texto.length > 0) {
      texto = "(" + texto;
      if (texto.length > 3) {
        texto = [texto.slice(0, 3), ") ", texto.slice(3)].join("");
      }
      if (texto.length > 12) {
        if (texto.length > 13)
          texto = [texto.slice(0, 10), "-", texto.slice(10)].join("");
        else texto = [texto.slice(0, 9), "-", texto.slice(9)].join("");
      }
      if (texto.length > 15) texto = texto.substr(0, 15);
    }
    return texto;
  };
  handleMaskCpfCnpj = cpf_cnpj => {
    var texto = cpf_cnpj;
    texto = texto.replace(/[^\d]/g, "");
    if (texto.length > 3) {
      texto = [texto.slice(0, 3), ".", texto.slice(3)].join("");
      if (texto.length > 7) {
        texto = [texto.slice(0, 7), ".", texto.slice(7)].join("");
      }
      if (texto.length > 11) {
        texto = [texto.slice(0, 11), "-", texto.slice(11)].join("");
        if (texto.length > 14) {
          texto = texto.replace(/[^\d]/g, "");
          texto = [
            texto.slice(0, 2),
            ".",
            texto.slice(2, 5),
            ".",
            texto.slice(5, 8),
            "/",
            texto.slice(8)
          ].join("");
          if (texto.length > 15) {
            texto = [texto.slice(0, 15), "-", texto.slice(15)].join("");
          }
          if (texto.length > 18) texto = texto.substr(0, 18);
        }
      }
    }
    return texto;
  };

  componentDidUpdate() {
    $(".input-date").mask("00/00/0000");
  }

  handleBlurCpfCnpj = val => {
    if (val !== "" && this.props.action === "NEW") {
      api
        .get(`/customers?cpf=${val}`)
        .then(data => {
          const {data: customer} = data;
          let id = customer.id;
          this.props.handleClose();
          this.props.handleEdit(id);
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  componentWillUnmount() {
    if (
      this.props.action !== "EDIT" &&
      this.props.action !== "EDIT_CUSTOMER_SALES" &&
      this.props.action !== "DETAIL"
    ) {
      this.props.setFields(this.props.values);
    }
  }

  render() {
    const props = this.props;
    return (
      <Fragment>
        <form onSubmit={props.handleSubmit}>
          <fieldset className="mb2">
            <legend>Dados gerais</legend>
            <div className="label-grid">
              <label
                className={
                  !!props.errors.cpf_cnpj && props.touched.cpf_cnpj
                    ? "error mr2"
                    : "mr2"
                }
              >
                CPF/CNPJ
                <input
                  type="text"
                  value={props.values.cpf_cnpj}
                  onChange={e => {
                    props.values.cpf_cnpj = this.handleMaskCpfCnpj(
                      e.target.value
                    );
                    this.forceUpdate();
                  }}
                  onBlur={e => this.handleBlurCpfCnpj(e.target.value)}
                  disabled={props.action === "DETAIL"}
                />
                <span>{props.errors.cpf_cnpj && props.errors.cpf_cnpj}</span>
              </label>
              <label
                className={
                  !!props.errors.name && props.touched.name
                    ? "error mr2"
                    : "mr2"
                }
              >
                Nome/Empresa
                <Field
                  name="name"
                  className="name"
                  disabled={props.action === "DETAIL"}
                  style={{
                    width: "30rem",
                    maxWidth: "30rem"
                  }}
                />
                <span>{props.errors.name && props.errors.name}</span>
              </label>
              <label className="mr2">
                Produto/Convênio
                <Field
                  component="select"
                  name="product_id"
                  disabled={props.action === "DETAIL"}
                >
                  <option value=""/>
                  {this.props.produtos.map(produto => (
                    <option value={produto.id} key={produto.id}>
                      {produto.name}
                    </option>
                  ))}
                </Field>
              </label>
              <label>
                Origem da venda
                <Field
                  component="select"
                  name="origin_id"
                  disabled={props.action === "DETAIL"}
                >
                  <Fragment>
                    <option value="0">
                      {this.state.loadingOrigins
                        ? "Carregando..."
                        : this.state.origins.length > 0
                          ? "Selecione"
                          : "Nenhum cadastro encontrado"}
                    </option>
                    {this.state.origins.map(origin => (
                      <option key={origin.id} value={origin.id}>
                        {origin.description}
                      </option>
                    ))}
                  </Fragment>
                </Field>
              </label>
            </div>
            <div className="label-grid">
              <label className="mr2">
                Data nascimento/abertura
                <Field
                  name="birthday"
                  className="input-date"
                  disabled={props.action === "DETAIL"}
                  onBlur={e => (props.values.birthday = e.target.value)}
                />
              </label>
              <label className="mr2">
                Estado Civil
                <Field
                  component="select"
                  name="marital_status"
                  disabled={props.action === "DETAIL"}
                >
                  <option value="0"/>
                  <option value="SOLTEIRO(A)">Solteiro(a)</option>
                  <option value="CASADO(A)">Casado(a)</option>
                  <option value="DIVORCIADO(A)">Divorciado(a)</option>
                  <option value="VIUVO(A)">Viúvo(a)</option>
                  <option value="SEPARADO(A)">Separado(a)</option>
                </Field>
              </label>
              <label className="mr2">
                Sexo
                <Field
                  component="select"
                  name="gender"
                  disabled={props.action === "DETAIL"}
                >
                  <option value="0"/>
                  <option value="MASCULINO">Masculino</option>
                  <option value="FEMININO">Feminino</option>
                </Field>
              </label>
              <label>
                Possui cartão?
                <Field
                  component="select"
                  name="has_card"
                  disabled={props.action === "DETAIL"}
                >
                  <option value=""/>
                  <option value="1">Sim</option>
                  <option value="0">Não</option>
                </Field>
              </label>
            </div>
            <div className="label-grid">
              <label className="mr2">
                RG/IE
                <Field
                  name="rg"
                  className="name"
                  disabled={props.action === "DETAIL"}
                />
              </label>
              <label className="mr2">
                Data expedição
                <Field
                  name="rg_date"
                  className="input-date"
                  disabled={props.action === "DETAIL"}
                  onBlur={e => (props.values.rg_date = e.target.value)}
                />
              </label>
              <label className="mr2">
                Orgão emissor
                <Field name="rg_org" disabled={props.action === "DETAIL"}/>
              </label>
              <label>
                Estado
                <Field
                  component="select"
                  name="rg_uf"
                  disabled={props.action === "DETAIL"}
                >
                  <option value=""/>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AM">AM</option>
                  <option value="AP">AP</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MG">MG</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="PR">PR</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="RS">RS</option>
                  <option value="SC">SC</option>
                  <option value="SE">SE</option>
                  <option value="SP">SP</option>
                  <option value="TO">TO</option>
                </Field>
              </label>
            </div>
            <div className="label-grid">
              <label className="mr2">
                Nome pai
                <Field
                  name="father_name"
                  className="name"
                  disabled={props.action === "DETAIL"}
                />
              </label>
              <label className="mr2">
                Nome mãe
                <Field
                  name="mother_name"
                  className="name"
                  disabled={props.action === "DETAIL"}
                />
              </label>
              <label>
                Nome cônjuge
                <Field
                  name="relation_name"
                  className="name"
                  disabled={props.action === "DETAIL"}
                />
              </label>
            </div>
            <div className="label-grid">
              <label className="mr2">
                E-mail
                <Field
                  name="email"
                  className="name lowercase"
                  disabled={props.action === "DETAIL"}
                />
              </label>
              <label>
                E-mail secundário
                <Field
                  name="email_commercial"
                  className="name lowercase"
                  disabled={props.action === "DETAIL"}
                />
              </label>
            </div>
            <div className="label-grid">
              <label className="mr2">
                Data admissão
                <Field
                  name="admission_date"
                  className="input-date "
                  disabled={props.action === "DETAIL"}
                  onBlur={e => (props.values.admission_date = e.target.value)}
                />
              </label>
              <label className="mr2">
                Salário
                <Field
                  name={`salary`}
                  component={CurrencyInput}
                  disabled={props.action === "DETAIL"}
                  decimalSeparator=","
                  thousandSeparator="."
                  prefix="R$ "
                />
              </label>
              <label className="mr2">
                Data demissão
                <Field
                  name="demission_date"
                  className="input-date "
                  disabled={props.action === "DETAIL"}
                  onBlur={e => (props.values.demission_date = e.target.value)}
                />
              </label>
              <label className="mr2">
                Nacionalidade
                <Field
                  name="nationality"
                  disabled={props.action === "DETAIL"}
                />
              </label>
              <label>
                Naturalidade
                <Field
                  name="naturalness"
                  disabled={props.action === "DETAIL"}
                />
              </label>
            </div>
            <Divider className="mb1"/>
            <label className="checkbox-label">
              <Checkbox
                checked={!!props.values.dead}
                value="1"
                id="dead"
                name="dead"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                disabled={props.action === "DETAIL"}
                classes={{
                  root: "check",
                  checked: "checked"
                }}
              />
              <span className="checkbox-description">Cliente falecido</span>
            </label>
            <Divider className="mb1"/>
            <label className="checkbox-label">
              <Checkbox
                checked={!!props.values.illiterate}
                value="1"
                id="illiterate"
                name="illiterate"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                disabled={props.action === "DETAIL"}
                classes={{
                  root: "check",
                  checked: "checked"
                }}
              />
              <span className="checkbox-description">Cliente analfabeto</span>
            </label>
            <Divider className="mb1"/>
            <label className="checkbox-label">
              <Checkbox
                checked={!!props.values.blacklisted}
                value="1"
                id="blacklisted"
                name="blacklisted"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                disabled={props.action === "DETAIL"}
                classes={{
                  root: "check",
                  checked: "checked"
                }}
              />
              <span className="checkbox-description">
                Cliente na lista negra
              </span>
            </label>
            {this.props.values.blacklisted ? (
              <div className="label-grid">
                <label className="mr2">
                  Motivo
                  <Field
                    name="notes_blacklist"
                    disabled={props.action === "DETAIL"}
                  />
                </label>
                <label>
                  Data
                  <Field
                    name="inserted_at_blacklist"
                    className="input-date i-started_at"
                    disabled={props.action === "DETAIL"}
                    onBlur={e =>
                      (props.values.inserted_at_blacklist = e.target.value)
                    }
                  />
                </label>
              </div>
            ) : (
              ""
            )}
            <Divider className="mb1"/>
            <label>
              Observações
              <Field
                component="textarea"
                name="obs"
                rows="6"
                className="field-password"
                disabled={props.action === "DETAIL"}
              />
            </label>
          </fieldset>
          <fieldset className="mb2">
            <legend>Endereço</legend>
            <div className="label-grid">
              <label className="mr2 i-zipcode">
                CEP
                <input
                  value={props.values.zipcode}
                  onBlur={e => {
                    props.values.zipcode = e.target.value;
                    $.getJSON(
                      "https://viacep.com.br/ws/" + e.target.value + "/json/",
                      function (endereco) {
                        props.values.address = endereco.logradouro;
                        props.values.complement = endereco.complemento;
                        props.values.district = endereco.bairro;
                        props.values.city = endereco.localidade;
                        props.values.state = endereco.uf;
                      }
                    );
                    this.forceUpdate();
                  }}
                  name="zipcode"
                  onChange={props.handleChange}
                  className="zipcode"
                  disabled={props.action === "DETAIL"}
                />
              </label>
              <label className="mr2 i-address">
                Logradouro
                <Field name="address" disabled={props.action === "DETAIL"}/>
              </label>
              <label className="mr2 i-number">
                Número
                <Field name="number" disabled={props.action === "DETAIL"}/>
              </label>
              <label className="i-complement">
                Complemento
                <Field name="complement" disabled={props.action === "DETAIL"}/>
              </label>
            </div>

            <div className="label-grid i-district">
              <label className="mr2">
                Bairro
                <Field name="district" disabled={props.action === "DETAIL"}/>
              </label>
              <label className="mr2 i-city">
                Cidade
                <Field name="city" disabled={props.action === "DETAIL"}/>
              </label>
              <label className="i-state">
                Estado
                <Field
                  component="select"
                  name="state"
                  disabled={props.action === "DETAIL"}
                >
                  <option value=""/>
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AM">AM</option>
                  <option value="AP">AP</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MG">MG</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="PR">PR</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="RS">RS</option>
                  <option value="SC">SC</option>
                  <option value="SE">SE</option>
                  <option value="SP">SP</option>
                  <option value="TO">TO</option>
                </Field>
              </label>
            </div>
          </fieldset>
          <FieldArray
            name="contacts"
            render={arrayHelpers => (
              <div>
                <fieldset className="mb2">
                  <legend>
                    Contatos
                    {props.action !== "DETAIL" && (
                      <Fragment>
                        <span className="ml2"/>
                        <PrimaryButton
                          type="button"
                          onClick={() => arrayHelpers.push("")}
                        >
                          <i className="fa fa-plus-circle"/>
                        </PrimaryButton>
                      </Fragment>
                    )}
                  </legend>
                  {props.values.contacts.map((contact, index) => (
                    <fieldset key={index} className="mb2">
                      <div className="label-grid flex-start">
                        <label className="i-phone mr2">
                          Número
                          <input
                            type="tel"
                            name={`contacts.${index}.number`}
                            value={contact.number}
                            onChange={e => {
                              if (
                                typeof props.values.contacts[index] === "string"
                              ) {
                                props.values.contacts[index] = {
                                  number: this.handleMaskPhone(e.target.value)
                                };
                              } else {
                                props.values.contacts[
                                  index
                                  ].number = this.handleMaskPhone(e.target.value);
                              }
                              this.forceUpdate();
                            }}
                            className="i-phone tel"
                            disabled={props.action === "DETAIL"}
                          />
                        </label>
                        <label className="i-phone mr2">
                          Tipo
                          <Field
                            component="select"
                            name={`contacts.${index}.type`}
                            disabled={props.action === "DETAIL"}
                          >
                            <option value=""/>
                            <option value="CELULAR"> Celular</option>
                            <option value="CELULAR (WHATSAPP)">
                              Celular (WhatsApp)
                            </option>
                            <option value="TELEFONE"> Telefone</option>
                          </Field>
                        </label>
                        <label className="i-phone mr2">
                          Uso
                          <Field
                            component="select"
                            name={`contacts.${index}.type_reference`}
                            disabled={props.action === "DETAIL"}
                          >
                            <option value=""/>
                            <option value="PESSOAL"> Pessoal</option>
                            <option value="TRABALHO"> Trabalho</option>
                            <option value="RECADO"> Recado</option>
                          </Field>
                        </label>
                        <label className="mr2">
                          Observação
                          <Field
                            name={`contacts.${index}.notes`}
                            disabled={props.action === "DETAIL"}
                          />
                        </label>
                        {props.action !== "DETAIL" && (
                          <label className="i-button align-self-center align-items-center mt0">
                            <SecondaryButton
                              onClick={() => arrayHelpers.remove(index)}
                            >
                              <DeleteIcon/>
                            </SecondaryButton>
                          </label>
                        )}
                      </div>
                    </fieldset>
                  ))}
                </fieldset>
              </div>
            )}
          />
          <FieldArray
            name="references"
            render={arrayHelpers => (
              <div>
                <fieldset className="mb2">
                  <legend>
                    Referências
                    {props.action !== "DETAIL" && (
                      <Fragment>
                        <span className="ml2"/>
                        <PrimaryButton
                          type="button"
                          onClick={() => arrayHelpers.push("")}
                        >
                          <i className="fa fa-plus-circle"/>
                        </PrimaryButton>
                      </Fragment>
                    )}
                  </legend>
                  {props.values.references.map((contact, index) => (
                    <fieldset key={index} className="mb2">
                      <div className="label-grid flex-start">
                        <label className="mr2">
                          Nome
                          <Field
                            name={`references.${index}.name`}
                            disabled={props.action === "DETAIL"}
                          />
                        </label>
                        <label className="i-phone mr2">
                          Número
                          <Field
                            type="tel"
                            name={`references.${index}.number`}
                            className="i-phone tel"
                            disabled={props.action === "DETAIL"}
                          />
                        </label>
                        {props.action !== "DETAIL" && (
                          <label className="i-button align-self-center align-items-center mt0">
                            <SecondaryButton
                              onClick={() => arrayHelpers.remove(index)}
                            >
                              <DeleteIcon/>
                            </SecondaryButton>
                          </label>
                        )}
                      </div>
                    </fieldset>
                  ))}
                </fieldset>
              </div>
            )}
          />
          <FieldArray
            name="benefits"
            render={arrayHelpers => (
              <div>
                <fieldset className="mb2">
                  <legend>
                    Benefícios/Matrículas
                    {props.action !== "DETAIL" && (
                      <Fragment>
                        <span className="ml2"/>
                        <PrimaryButton
                          type="button"
                          onClick={() => arrayHelpers.push("")}
                        >
                          <i className="fa fa-plus-circle"/>
                        </PrimaryButton>
                      </Fragment>
                    )}
                  </legend>
                  {props.values.benefits.map((contact, index) => (
                    <fieldset key={index} className="mb2">
                      {props.action !== "DETAIL" && (
                        <legend className="i-button align-self-center align-items-center mt0">
                          <SecondaryButton
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            <DeleteIcon/>
                          </SecondaryButton>
                        </legend>
                      )}
                      <div className="label-grid flex-start">
                        <label
                          className="mr2 i-phone"
                          style={{
                            width: "15rem",
                            maxWidth: "15rem"
                          }}
                        >
                          N. Benefício/Matrícula
                          <Field
                            className="i-phone code"
                            name={`benefits.${index}.number`}
                            disabled={props.action === "DETAIL"}
                            style={{
                              width: "15rem",
                              maxWidth: "15rem"
                            }}
                          />
                        </label>
                        <label className="mr2">
                          Senha
                          <Field
                            name={`benefits.${index}.password`}
                            disabled={props.action === "DETAIL"}
                            className="field-password"
                          />
                        </label>
                        <label className=" mr2">
                          Espécie
                          <Field
                            type="tel"
                            name={`benefits.${index}.breed`}
                            disabled={props.action === "DETAIL"}
                          />
                        </label>
                        <label className="i-phone mr2">
                          UF
                          <Field
                            component="select"
                            name={`benefits.${index}.uf`}
                            disabled={props.action === "DETAIL"}
                          >
                            <option value=""/>
                            <option value="AC">AC</option>
                            <option value="AL">AL</option>
                            <option value="AM">AM</option>
                            <option value="AP">AP</option>
                            <option value="BA">BA</option>
                            <option value="CE">CE</option>
                            <option value="DF">DF</option>
                            <option value="ES">ES</option>
                            <option value="GO">GO</option>
                            <option value="MA">MA</option>
                            <option value="MG">MG</option>
                            <option value="MS">MS</option>
                            <option value="MT">MT</option>
                            <option value="PA">PA</option>
                            <option value="PB">PB</option>
                            <option value="PE">PE</option>
                            <option value="PI">PI</option>
                            <option value="PR">PR</option>
                            <option value="RJ">RJ</option>
                            <option value="RN">RN</option>
                            <option value="RO">RO</option>
                            <option value="RR">RR</option>
                            <option value="RS">RS</option>
                            <option value="SC">SC</option>
                            <option value="SE">SE</option>
                            <option value="SP">SP</option>
                            <option value="TO">TO</option>
                          </Field>
                        </label>
                        <label className="i-phone mr2">
                          Salário
                          <Field
                            name={`benefits.${index}.salary`}
                            className="i-phone"
                            component={CurrencyInput}
                            disabled={props.action === "DETAIL"}
                            decimalSeparator=","
                            thousandSeparator="."
                            prefix="R$ "
                          />
                        </label>
                        <label className="i-phone mr2">
                          Margem
                          <Field
                            name={`benefits.${index}.reference`}
                            className="i-phone"
                            component={CurrencyInput}
                            disabled={props.action === "DETAIL"}
                            decimalSeparator=","
                            thousandSeparator="."
                            prefix="R$ "
                          />
                        </label>
                      </div>
                      <div className="label-grid">
                        <label className="mr2">
                          Tipo conta
                          <Field
                            component="select"
                            name={`benefits.${index}.bank_account.type`}
                            disabled={props.action === "DETAIL"}
                          >
                            <option value=""/>
                            <option value="Cartão Magnético">
                              Cartão Magnético
                            </option>
                            <option value="Conta Corrente">
                              Conta Corrente
                            </option>
                            <option value="Conta Poupança">
                              Conta Poupança
                            </option>
                            <option value="Ordem de Pagamento">
                              Ordem de Pagamento
                            </option>
                            <option value="Vale Postal">Vale Postal</option>
                          </Field>
                        </label>
                        <label className="mr2">
                          Banco
                          <Field
                            name={`benefits.${index}.bank_account.bank_id`}
                            component="select"
                            className="bank_id i-bank_id"
                            disabled={
                              props.action === "DETAIL" ||
                              props.totalBancos === 0
                            }
                          >
                            <option value="">
                              {props.loadingBancos
                                ? "Carregando..."
                                : props.totalBancos > 0
                                  ? "Selecione"
                                  : "Nenhum cadastro encontrado"}
                            </option>
                            {props.bancos.map(banco => (
                              <option key={banco.id} value={banco.id}>
                                {banco.name}
                              </option>
                            ))}
                          </Field>
                        </label>
                        <label className="i-phone mr2">
                          Agência
                          <Field
                            name={`benefits.${index}.bank_account.agency`}
                            className="i-phone"
                            disabled={props.action === "DETAIL"}
                          />
                        </label>
                        <label className="i-phone mr2">
                          Número conta
                          <Field
                            name={`benefits.${index}.bank_account.account_number`}
                            className="i-phone"
                            disabled={props.action === "DETAIL"}
                          />
                        </label>
                      </div>
                    </fieldset>
                  ))}
                </fieldset>
              </div>
            )}
          />
          {props.action !== "DETAIL" && (
            <Fragment>
              <SubmitButton disabled={props.loading}>
                {(props.action === "NEW" ||
                  props.action === "NEW_CUSTOMER_SALES") &&
                "Cadastrar"}
                {(props.action === "EDIT" ||
                  props.action === "EDIT_CUSTOMER_SALES") &&
                "Salvar Alterações"}
              </SubmitButton>
              <span className="mr1"/>
              {props.action !== "EDIT_CUSTOMER_SALES" ? (
                <DefaultButton
                  disabled={props.loading}
                  onClick={() => props.handleClose()}
                  border="border"
                >
                  Cancelar
                </DefaultButton>
              ) : (
                <DefaultButton
                  disabled={props.loading}
                  onClick={() => props.handleClose()}
                  border="border"
                >
                  Cancelar
                </DefaultButton>
              )}
            </Fragment>
          )}
        </form>
      </Fragment>
    );
  }
}

const ClientesForm = withFormik({
  mapPropsToValues: props => ({
    name:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.name
        : props.formFields.name,
    product_id:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.product_id
        : props.formFields.product_id,
    cpf_cnpj:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.cpf_cnpj
        : props.formFields.cpf_cnpj,
    origin_id:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.origin_id
        : props.formFields.origin_id,
    birthday:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.birthday
        : props.formFields.birthday,
    marital_status:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.marital_status
        ? props.clientes.item.marital_status
        : ""
        : props.formFields.marital_status,
    gender:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.gender
        ? props.clientes.item.gender
        : ""
        : props.formFields.gender,
    has_card:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.has_card
        ? props.clientes.item.has_card
        : ""
        : props.formFields.has_card,
    rg:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.rg
        : props.formFields.rg,
    rg_date:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.rg_date
        : props.formFields.rg_date,
    rg_org:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.rg_org
        : props.formFields.rg_org,
    rg_uf:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.rg_uf
        ? props.clientes.item.rg_uf
        : ""
        : props.formFields.rg_uf,
    mother_name:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.mother_name
        : props.formFields.mother_name,
    father_name:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.father_name
        : props.formFields.father_name,
    relation_name:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.relation_name
        : props.formFields.relation_name,
    email:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.email
        : props.formFields.email,
    email_commercial:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.email_commercial
        : props.formFields.email_commercial,
    admission_date:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.admission_date
        : props.formFields.admission_date,
    salary:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.salary
        : props.formFields.salary,
    demission_date:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.demission_date
        : props.formFields.demission_date,
    dead:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.dead
        : props.formFields.dead,
    illiterate:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.illiterate
        : props.formFields.illiterate,
    blacklisted:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.blacklisted
        : props.formFields.blacklisted,
    notes_blacklist:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.blacklisted
        ? props.clientes.item.blacklist
          ? props.clientes.item.blacklist.notes
          : ""
        : ""
        : props.formFields.blacklisted
        ? props.formFields.item.blacklist
          ? props.formFields.item.blacklist.notes
          : ""
        : "",
    inserted_at_blacklist:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.blacklisted
        ? props.clientes.item.blacklist
          ? props.clientes.item.blacklist.inserted_at
          : ""
            ? moment(props.clientes.item.blacklist.inserted_at).format(
              "DD/MM/YYYY"
            )
            : ""
        : ""
        : props.formFields.blacklisted
        ? props.formFields.item.blacklist
          ? props.formFields.item.blacklist.inserted_at
          : ""
            ? moment(props.formFields.item.blacklist.inserted_at).format(
              "DD/MM/YYYY"
            )
            : ""
        : "",
    obs:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.obs
        : props.formFields.obs,
    zipcode:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.addresses[0]
        ? props.clientes.item.addresses[0].zipcode !== null
          ? props.clientes.item.addresses[0].zipcode
          : ""
        : ""
        : props.formFields.zipcode,
    address:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.addresses[0]
        ? props.clientes.item.addresses[0].address !== null
          ? props.clientes.item.addresses[0].address
          : ""
        : ""
        : props.formFields.address,
    number:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.addresses[0]
        ? props.clientes.item.addresses[0].number !== null
          ? props.clientes.item.addresses[0].number
          : ""
        : ""
        : props.formFields.number,
    district:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.addresses[0]
        ? props.clientes.item.addresses[0].district !== null
          ? props.clientes.item.addresses[0].district
          : ""
        : ""
        : props.formFields.district,
    city:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.addresses[0]
        ? props.clientes.item.addresses[0].city !== null
          ? props.clientes.item.addresses[0].city
          : ""
        : ""
        : props.formFields.city,
    state:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.addresses[0]
        ? props.clientes.item.addresses[0].state !== null
          ? props.clientes.item.addresses[0].state
          : ""
        : ""
        : props.formFields.state,
    complement:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.addresses[0]
        ? props.clientes.item.addresses[0].complement !== null
          ? props.clientes.item.addresses[0].complement
          : ""
        : ""
        : props.formFields.complement,
    contacts:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.contacts
        : props.formFields.contacts,
    references:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.references
        : props.formFields.references,
    benefits:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.benefits
        : props.formFields.benefits,
    nationality:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.nationality
        : props.formFields.nationality,
    naturalness:
      props.action === "EDIT" ||
      props.action === "EDIT_CUSTOMER_SALES" ||
      props.action === "DETAIL"
        ? props.clientes.item.naturalness
        : props.formFields.naturalness
  }),
  validateOnChange: true,
  validateOnBlur: false,
  validate: values => {
    const errors = {};
    if (!values.name) {
      errors.name = FORM_ERRORS.REQUIRED;
    }
    if (!values.cpf_cnpj) {
      errors.cpf_cnpj = FORM_ERRORS.REQUIRED;
    }
    return errors;
  },
  handleSubmit: (values, {props, setSubmitting, setErrors}) => {
    const name = values.name ? values.name.toUpperCase() : "";
    const id = props.clientes.item.id;
    const cpf_cnpj = values.cpf_cnpj;
    const product_id = values.product_id;
    const origin_id = values.origin_id;
    const birthday = values.birthday;
    const marital_status = values.marital_status
      ? values.marital_status.toUpperCase()
      : "";
    const gender = values.gender ? values.gender.toUpperCase() : "";
    const has_card = values.has_card;
    const rg = values.rg;
    const rg_date = values.rg_date;
    const rg_org = values.rg_org;
    const rg_uf = values.rg_uf;
    const mother_name = values.mother_name
      ? values.mother_name.toUpperCase()
      : "";
    const father_name = values.father_name
      ? values.father_name.toUpperCase()
      : "";
    const relation_name = values.relation_name
      ? values.relation_name.toUpperCase()
      : "";
    const email = values.email;
    const email_commercial = values.email_commercial;
    const admission_date = values.admission_date;
    const salary = formatMoney(values.salary);
    const demission_date = values.demission_date;
    const obs = values.obs;
    const dead = values.dead;
    const illiterate = values.illiterate;
    const blacklisted = values.blacklisted;
    let blacklist = null;
    if (blacklisted) {
      blacklist = {
        notes: values.notes_blacklist,
        inserted_at: values.inserted_at_blacklist
      };
    }
    const zipcode = values.zipcode;
    const address = values.address;
    const number = values.number;
    const district = values.district;
    const city = values.city;
    const state = values.state;
    const complement = values.complement;
    const contacts = values.contacts ? values.contacts : [];
    const addresses = [
      {
        zipcode,
        address,
        number,
        district,
        city,
        state,
        complement
      }
    ];
    const references = values.references ? values.references : [];
    const benefits =
      values.benefits && values.benefits.length > 0
        ? values.benefits.map(benefit => {
          if (typeof benefit !== "string") {
            benefit.reference = formatMoney(benefit.reference);
            benefit.salary = formatMoney(benefit.salary);
          }
          return benefit;
        })
        : [];
    const nationality = values.nationality;
    const naturalness = values.naturalness;
    props.action === "EDIT" || props.action === "EDIT_CUSTOMER_SALES"
      ? props.editClientes({
        name,
        product_id,
        cpf_cnpj,
        origin_id,
        birthday,
        marital_status,
        gender,
        has_card,
        rg,
        rg_date,
        rg_org,
        rg_uf,
        mother_name,
        father_name,
        relation_name,
        email,
        email_commercial,
        admission_date,
        salary,
        demission_date,
        obs,
        dead,
        illiterate,
        blacklisted,
        blacklist,
        addresses,
        contacts,
        references,
        benefits,
        nationality,
        naturalness,
        id
      })
      : props.addClientes({
        name,
        product_id,
        cpf_cnpj,
        origin_id,
        birthday,
        marital_status,
        gender,
        has_card,
        rg,
        rg_date,
        rg_org,
        rg_uf,
        mother_name,
        father_name,
        relation_name,
        email,
        email_commercial,
        admission_date,
        salary,
        demission_date,
        obs,
        dead,
        illiterate,
        blacklisted,
        blacklist,
        addresses,
        contacts,
        references,
        benefits,
        nationality,
        naturalness
      });
  }
})(Form);
const mapStateToProps = state => ({
  clientes: state.clientes,
  formFields: state.clientesStores.formFields,
  action: state.clientesStores.action,
  bancos: state.bancos.dataList,
  loadingBancos: state.bancos.loadingSelect,
  totalBancos: state.bancos.dataList.length,
  loading: state.loading.loading,
  produtos: state.produtos.dataList,
  loadingProdutos: state.produtos.loadingSelect,
  totalProdutos: state.produtos.dataList.length
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...ClientesActions,
      ...StorePageActions,
      ...ModalActions,
      ...ModalCustomerActions,
      ...ProdutosActions
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(ClientesForm);



// WEBPACK FOOTER //
// ./src/components/Forms/Clientes/index.js